import { useState } from "react";
import { Notification, useMessagedAsyncFn } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { BusinessIbanApi } from "./businessIbanApi";

export const useActiveIBAN = () => {
  const { t } = useAppTranslation();
  const [activeIBAN, setActiveIBAN] = useState<string | null>(null);

  const [notification, contextHolder] = Notification.useNotification({
    top: 16,
    duration: 5,
    maxCount: 1,
    placement: "top",
  });

  const [getActiveIBANState, getActiveIBAN] = useMessagedAsyncFn(
    async () => {
      try {
        const response = await BusinessIbanApi.getBusinessIban();
        setActiveIBAN(response?.iban || null);
        return response;
      } catch (error) {
        setActiveIBAN(null);
        notification.error({
          message: t("profile.bank.errorLoadingActiveIBAN"),
          closable: true,
        });
        throw error;
      }
    },
    [],
    undefined,
    { useProgress: true },
  );

  const [updateActiveIBANState, updateActiveIBAN] = useMessagedAsyncFn(
    async (iban: string) => {
      try {
        const response = await BusinessIbanApi.updateBusinessIban({ iban });
        setActiveIBAN(response?.iban || null);
        return response;
      } catch (error) {
        notification.error({
          message: t("profile.bank.errorUpdatingActiveIBAN"),
          closable: true,
        });
        throw error;
      }
    },
    [],
    undefined,
    { useProgress: true },
  );

  return {
    activeIBAN,
    getActiveIBAN,
    updateActiveIBAN,
    loading: getActiveIBANState.loading || updateActiveIBANState.loading,
    error: getActiveIBANState.error || updateActiveIBANState.error,
    contextHolder,
  };
};

